import { samplesAPI } from '../api/recommendation-api/api.js';
import { logError } from './error-service.js';

const fetchSamples = async ({ cartArticles, siteId, language, customerId, options, }) => {
    try {
        return await samplesAPI.getSamples(cartArticles, siteId, language, customerId, options);
    }
    catch (error) {
        logError(error, 'getSamples');
        throw error;
    }
};

export { fetchSamples };
//# sourceMappingURL=samples-service.js.map
